export const getV3AssetPath = (path: string, isV3: boolean, assetPath: string) => {
    return isV3 ? `${assetPath}${path}` : path;
};
